import { Moon, Sun, Palette } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const PALETTES = [
  { key: "teal-medical", label: "Teal Medical" },
  { key: "indigo", label: "Clinical Indigo" },
  { key: "mono-light", label: "Paper Studio" },
  { key: "mono-dark", label: "Obsidian Slate" },
];

export function ThemeToggle() {
  const { palette, setPalette, dark, setDark } = useTheme();
  const lockedDark = palette === "mono-dark";
  const lockedLight = palette === "mono-light";
  return (
    <div className="flex items-center gap-1">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" data-testid="palette-menu-btn" className="rounded-full">
            <Palette className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-popover">
          <DropdownMenuLabel>Theme</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {PALETTES.map((p) => (
            <DropdownMenuItem
              key={p.key}
              data-testid={`palette-${p.key}`}
              onClick={() => setPalette(p.key)}
              className={palette === p.key ? "font-semibold text-primary" : ""}
            >
              {p.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      {!lockedDark && !lockedLight && (
        <Button
          variant="ghost"
          size="icon"
          data-testid="dark-toggle-btn"
          className="rounded-full"
          onClick={() => setDark(!dark)}
        >
          {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
      )}
    </div>
  );
}
